import { PrimaryTheme } from '@deckee/deck-hand';

/** System UI sans stack — app-main renders in the host OS UI font. */
const SYSTEM_SANS =
  'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji"';

const theme: typeof PrimaryTheme = {
  ...PrimaryTheme,
  fonts: {
    ...PrimaryTheme.fonts,
    primary: SYSTEM_SANS,
    text: SYSTEM_SANS,
  },
};

export default theme;
